(function () {
  var roots = document.querySelectorAll("[data-shf-folix]");
  if (!roots.length) return;

  var reveal = function (node) {
    node.classList.add("is-visible");
  };

  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18 }
    );

    roots.forEach(function (root) {
      observer.observe(root);
    });
  } else {
    roots.forEach(reveal);
  }

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-folix-scroll-to-atc]");
    if (!trigger) return;

    var target = document.querySelector(".product-form__actions") || document.querySelector('form[action*="/cart/add"]');
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "center" });
  });
})();
